const ErrorMessages = {
    EMAIL_NOT_CONFIRMED: "Email not confirmed",
    EMAIL_NOT_CONFIRMED_CHECK_EMAIL:
        "Email not confirmed. Check your email for a confirmation link to login.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    REQUIRED_FIELD: "This field is required.",
    USER_NOT_FOUND: "User not found",
};

export { ErrorMessages };
